import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";
import { baseURL } from "../../../config/api";

export const EditAutonomousOperator = () => {
    const navigate = useNavigate();
    const idNumber = useLocation();

    const [name, setName] = useState<string>("");
    const [provider, setProvider] = useState<string>("");
    const [version, setVersion] = useState<string>("");
    const [status, setStatus] = useState<string>("available");
    const [enabled, setEnabled] = useState<string>("Yes");
    const [description, setDescription] = useState<string>("");

    const [operatorData, setOperatorData] =
        useState<any>(null);

    const [pleaseWaitPopup, setPleaseWaitPopup] =
        useState<boolean>(false);

    useEffect(() => {
        setPleaseWaitPopup(true);

        axios
            .get(
                `${baseURL}autonomous-operators/${idNumber?.state}`
            )
            .then((response) => {
                const operator =
                    response?.data?.data;

                setOperatorData(operator);

                setName(
                    operator?.name ?? ""
                );

                setProvider(
                    operator?.provider ?? ""
                );

                setVersion(
                    operator?.version ?? ""
                );

                setStatus(
                    operator?.status ?? "available"
                );

                setEnabled(
                    operator?.is_active
                        ? "Yes"
                        : "No"
                );

                setDescription(
                    operator?.description ?? ""
                );

                setPleaseWaitPopup(false);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);

                console.error(
                    "Error fetching autonomous operator:",
                    error
                );
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber]);

    const handleSubmit = async (
        e: React.FormEvent<HTMLFormElement>
    ) => {
        e.preventDefault();

        setPleaseWaitPopup(true);

        const payload = {
            ...operatorData,

            name: name.trim(),
            provider: provider.trim(),
            version: version.trim(),
            status,
            is_active: enabled === "Yes",
            description: description.trim()
        };

        await axios
            .put(
                `${baseURL}autonomous-operators/${idNumber?.state}`,
                payload,
                {
                    headers: {
                        "Content-Type":
                            "application/json"
                    },
                    withCredentials: false
                }
            )
            .then(() => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);

                console.error(
                    "Error updating autonomous operator:",
                    error
                );
            });
    };


    return (
        <>
            <div className="px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto">

                <div className="w-full bg-white p-4 rounded-md">

                    <h2 className="text-lg font-semibold">
                        Edit Autonomous Operator
                    </h2>

                    <div className="mt-2 p-2">

                        <form onSubmit={handleSubmit}>

                            <div className="w-full">

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Name{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={name}
                                            placeholder="Name"
                                            onChange={(e) =>
                                                setName(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Provider{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={provider}
                                            placeholder="Provider"
                                            onChange={(e) =>
                                                setProvider(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                    </div>

                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Version{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={version}
                                            placeholder="Version"
                                            onChange={(e) =>
                                                setVersion(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Status{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={status}
                                            onChange={(e) =>
                                                setStatus(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        >
                                            <option value="available">
                                                Available
                                            </option>

                                            <option value="unavailable">
                                                Unavailable
                                            </option>

                                            <option value="maintenance">
                                                Maintenance
                                            </option>

                                            <option value="inactive">
                                                Inactive
                                            </option>
                                        </select>
                                    </div>

                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Active
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={enabled}
                                            onChange={(e) =>
                                                setEnabled(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="Yes">
                                                Yes
                                            </option>

                                            <option value="No">
                                                No
                                            </option>
                                        </select>
                                    </div>

                                </div>

                                <div className="grid grid-cols-1 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Description
                                        </label>

                                        <textarea
                                            rows={4}
                                            value={description}
                                            onChange={(e) =>
                                                setDescription(
                                                    e.target.value
                                                )
                                            }
                                            placeholder="Description"
                                            className="w-full p-4 border border-gray-300 rounded-md bg-white resize-none outline-none focus:border-primary"
                                        />
                                    </div>

                                </div>

                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() =>
                                            navigate(-1)
                                        }
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-white text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <PleasewaitPopup
                showPopup={pleaseWaitPopup}
            />
        </>
    );
};